import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, vShow as _vShow, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"position":"relative"},
  class: "invoice-information-edit bg-white p-5 border border-gray-200 rounded-2xl dark:border-gray-800 lg:p-6"
}
const _hoisted_2 = { class: "p-5" }
const _hoisted_3 = { class: "space-y-6 border-t border-gray-100 p-5 sm:p-6 dark:border-gray-800" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "relative w-full" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "fa-solid fa-download" }
const _hoisted_9 = { class: "fa-solid fa-spinner animate-spin" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "pt-5" }
const _hoisted_15 = { class: "overlay rounded-2xl" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_basic_button = _resolveComponent("basic_button")
  const _component_money_input = _resolveComponent("money_input")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_basic_button, {
        onClick: _cache[0] || (_cache[0] = $event => ($setup.toggle_invoice_comparison())),
        size: $setup.Size.large
      }, {
        default: _withCtx(() => _cache[18] || (_cache[18] = [
          _createTextVNode(" Toggle Invoice Comparison ")
        ])),
        _: 1 /* STABLE */,
        __: [18]
      }, 8 /* PROPS */, ["size"])
    ]),
    _cache[27] || (_cache[27] = _createElementVNode("h4", { class: "text-lg font-semibold text-gray-800 dark:text-white/90 flex justify-between items-center" }, " Invoice Information ", -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("div", null, [
          _cache[19] || (_cache[19] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Vendor ", -1 /* CACHED */)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            disabled: $setup.disabled,
            onInput: _cache[1] || (_cache[1] = $event => ($setup.update_invoice($setup.props.file, $setup.invoice, $setup.invoice_information))),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.invoice_information.vendor) = $event)),
            id: "vendor",
            tabindex: "110",
            class: "dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_4), [
            [_vModelText, $setup.invoice_information.vendor]
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[20] || (_cache[20] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Project number ", -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              disabled: $setup.disabled || $setup.project_loading,
              id: "project_NaN",
              onInput: _cache[3] || (_cache[3] = $event => ($setup.update_invoice($setup.props.file, $setup.invoice, $setup.invoice_information))),
              onKeypress: _cache[4] || (_cache[4] = _withKeys($event => ($setup.fetch_project_data($setup.props.file, $setup.invoice, $setup.invoice_information.project_NaN)), ["enter"])),
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($setup.invoice_information.project_NaN) = $event)),
              tabindex: "120",
              class: "dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 disabled:bg-gray-200"
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_6), [
              [_vModelText, $setup.invoice_information.project_NaN]
            ]),
            _createElementVNode("button", {
              type: "button",
              disabled: $setup.disabled || $setup.project_loading,
              onClick: _cache[6] || (_cache[6] = $event => ($setup.fetch_project_data($setup.props.file, $setup.invoice, $setup.invoice_information.project_NaN))),
              class: "absolute inset-y-0 right-0 flex items-center px-3 text-gray-500 hover:text-gray-700 dark:text-white/50 dark:hover:text-white"
            }, [
              _withDirectives(_createElementVNode("i", _hoisted_8, null, 512 /* NEED_PATCH */), [
                [_vShow, !$setup.project_loading]
              ]),
              _withDirectives(_createElementVNode("i", _hoisted_9, null, 512 /* NEED_PATCH */), [
                [_vShow, $setup.project_loading]
              ]),
              _createCommentVNode(" You can replace this with an icon e.g. from Heroicons or Lucide ")
            ], 8 /* PROPS */, _hoisted_7)
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[21] || (_cache[21] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Project Manager ", -1 /* CACHED */)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            disabled: $setup.disabled,
            onInput: _cache[7] || (_cache[7] = $event => ($setup.update_invoice($setup.props.file, $setup.invoice, $setup.invoice_information))),
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($setup.invoice_information.project_manager) = $event)),
            tabindex: "130",
            class: "dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_10), [
            [_vModelText, $setup.invoice_information.project_manager]
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[22] || (_cache[22] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Customer ", -1 /* CACHED */)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            disabled: $setup.disabled,
            onInput: _cache[9] || (_cache[9] = $event => ($setup.update_invoice($setup.props.file, $setup.invoice, $setup.invoice_information))),
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($setup.invoice_information.customer) = $event)),
            tabindex: "140",
            class: "dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_11), [
            [_vModelText, $setup.invoice_information.customer]
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[23] || (_cache[23] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Project description ", -1 /* CACHED */)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            disabled: $setup.disabled,
            onInput: _cache[11] || (_cache[11] = $event => ($setup.update_invoice($setup.props.file, $setup.invoice, $setup.invoice_information))),
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (($setup.invoice_information.project_description) = $event)),
            tabindex: "150",
            class: "dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_12), [
            [_vModelText, $setup.invoice_information.project_description]
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[24] || (_cache[24] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Invoice Number ", -1 /* CACHED */)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            disabled: $setup.disabled,
            onInput: _cache[13] || (_cache[13] = $event => ($setup.update_invoice($setup.props.file, $setup.invoice, $setup.invoice_information))),
            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => (($setup.invoice_information.invoice_NaN) = $event)),
            tabindex: "160",
            class: "dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_13), [
            [_vModelText, $setup.invoice_information.invoice_NaN]
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[25] || (_cache[25] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Total ", -1 /* CACHED */)),
          _createVNode(_component_money_input, {
            disabled: $setup.disabled,
            onInput: _cache[15] || (_cache[15] = $event => ($setup.update_invoice($setup.props.file, $setup.invoice, $setup.invoice_information))),
            modelValue: $setup.invoice_information.total,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => (($setup.invoice_information.total) = $event)),
            tabindex: "170"
          }, null, 8 /* PROPS */, ["disabled", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_basic_button, {
            onClick: _cache[17] || (_cache[17] = $event => ($setup.start_stamping())),
            disabled: $setup.disabled,
            size: $setup.Size.large
          }, {
            default: _withCtx(() => [
              _cache[26] || (_cache[26] = _createElementVNode("i", { class: "fa-solid fa-stamp" }, null, -1 /* CACHED */)),
              _withDirectives(_createElementVNode("span", null, " Place Stamp ", 512 /* NEED_PATCH */), [
                [_vShow, !$setup.is_stamping]
              ]),
              _withDirectives(_createElementVNode("span", null, " Cancel Placing Stamp ", 512 /* NEED_PATCH */), [
                [_vShow, $setup.is_stamping]
              ])
            ]),
            _: 1 /* STABLE */,
            __: [26]
          }, 8 /* PROPS */, ["disabled", "size"])
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_15, [
      _createCommentVNode(" Select single invoice or merge invoices to edit invoice information ")
    ], 512 /* NEED_PATCH */), [
      [_vShow, $setup.multiple_invoices_selected || $setup.invoice === null]
    ])
  ]))
}